import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedCalculator"] */ "/vercel/path0/src/app/dienstleistungen/webdesign/speed-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path0/src/components/home/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverInfo"] */ "/vercel/path0/src/components/HoverInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrowserFrame","PhoneFrame"] */ "/vercel/path0/src/components/mockups/frames.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTabs"] */ "/vercel/path0/src/components/services/reference-tabs.tsx");
